import { Popover } from "antd";

import React, { useState } from "react";
import "../../styles/Broadcast.css";

import RadioButton from "../../../../components/form/radio/RadioButton";
import { ICONS } from "../../../../assets/icons";

const daily_messaging_limit = {
  TIER_50: "50",
  TIER_250: "250",
  TIER_1K: "1000",
  TIER_2K: "2000",
  TIER_10K: "10000",
  TIER_100K: "100000",
  TIER_UNLIMITED: "Unlimited",
};

const quality_rating = {
  UNKNOWN: "Unknown",
  GREEN: "High",
  RED: "Low",
  YELLOW: "Medium",
};

const SendForm = ({
  numberDetails,
  handleClick,
  setSelectedRole,
  selectedRole,
  selectedItemId,
  broadCasts,
  className,
  spanClass,
  inputClass,
  list,
}) => {
  const [popoverVisible, setPopoverVisible] = useState(false);
  const handleVisibleChange = (visible) => {
    setPopoverVisible(visible);
  };

  const whatsappNumbers = numberDetails?.wapp_business_num;

  const SendPeople = () => {
    return (
      <div className="flex-column">
        <div className="flex-column w-100 align-left p-4" style={{ borderBottom: "1px solid #eee" }}>
            <div className="flex-row justify-left align-left w-100">
                <span style={{ fontSize: "14px", fontWeight: "500" }}>
                    Messaging Limit: {daily_messaging_limit[numberDetails?.messaging_limit_tier_name] || numberDetails?.messaging_limit} / 24hr
                </span>
            </div>
            <div className="flex-column space-between align-left">
                <span style={{ fontSize: "13px" }}>
                    Remaining: <span style={{ color: (numberDetails?.message_limit_reached) ? "#d93025" : "#188038", fontWeight: "600" }}>{numberDetails?.remaining_messages}</span>
                  {numberDetails?.message_limit_reached && (
                      <span className="ml-10" style={{ color: "#d93025", fontSize: "11px", fontWeight: "bold", background: "#fce8e6", padding: "2px 6px", borderRadius: "10px" }}>Limit Reached</span>
                  )}
                </span>
            </div>
        </div>
        <div className="popover-container">
          <div  className={`flex-column`}>
          {whatsappNumbers?.map((data) => {
            return (
              <div
                className="flex-column pointer "
                key={data?.id}
                onClick={() => {
                  if (selectedItemId !== data.id) {
                    setSelectedRole(data);
                    setPopoverVisible(true);
                    handleClick(data?.id);
                    setPopoverVisible(false);
                  }
                }}
              >
                <div className=" flex-row w-100 space-between">
                  <div className=" flex-row  w-100  space-between ">
                    <p className="pr-10">{data?.send_from_phone_name} </p>

                    <div
                      className="w-30 flex-row flex-end"
                      style={{
                        transform: "translate(16px, 14px)",
                      }}
                    >
                      {selectedItemId === data?.id && (
                        <RadioButton selected={selectedItemId === data.id} />
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex-row align-center pt-5">
                  <span
                    style={{
                      borderRight: "1px solid #D1D3D8",
                      paddingRight: "15px",
                      height: "16px",
                      marginRight: "5px",
                    }}
                  >
                    <span className="pr-5"> {data?.country_code}</span>
                    {data?.send_from_phone_number}
                  </span>
                  <div
                    className={`TemplateList-quality1 flex-row align-center   ${
                      quality_rating[data?.quality_rating]
                    }`}
                  >
                    <span className="border-q"></span>
                    <span className=" broadcast-status  flex-row align-center justify-center pr-10 pl-5">
                      {quality_rating[data?.quality_rating]}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        </div>
      </div>
    );
  };
  return (
    <div className="flex-column  ">
      <Popover
        content={<SendPeople />}
        trigger="click"
        placement="bottom"
        arrow={false}
        className="antd"
        open={popoverVisible}
        onOpenChange={handleVisibleChange}
      >
        <div className="flex-column input-label-text">
          <span>Send From</span>
          <span className={`mt-5 mb-5 text-[0.75vw] font-[400] text-[var(--darkgrey)] ${spanClass}`}>
            Select the WhatsApp number you would like to send the messages.
          </span>
          <div
            className={`message-container flex-row align-center space-between pointer ${selectedRole?.send_from_phone_name ||
              broadCasts?.settings?.send_from_phone_name
              ? ""
              : "opacity-50"
              } ${inputClass}`}
          >
            <div className="flex-row align-center justify-center pointer">
              {(selectedRole?.send_from_phone_name ||
                broadCasts?.settings?.send_from_phone_name) &&
                (broadCasts?.settings?.send_from_phone_name ||
                  !selectedRole?.send_from_phone_name) && (
                  <img src={ICONS?.whatsApp} alt="whatsappLogo" />
                )}
              {!list && (
                <p className="selected-name ">
                  {(selectedRole && selectedRole.send_from_phone_name) ||
                    (!selectedRole &&
                      broadCasts &&
                      broadCasts.settings &&
                      broadCasts.settings.send_from_phone_name)
                    ? selectedRole
                      ? selectedRole.send_from_phone_name
                      : broadCasts.settings.send_from_phone_name
                    : "Choose WhatsApp Number"}
                </p>
              )}
              {list && (
                <span>
                  {list && list?.length > 0
                    ? list?.[0]?.send_from_phone_name
                    : "Choose WhatsApp Number"}
                </span>
              )}
            </div>
            <img
              src={ICONS?.modelDropdownIcon}
              alt="modelDropdownIcon"
              className="pointer"
            />
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default SendForm;
